import {
    SHOW_NOTIFICATION,
    HIDE_NOTIFICATION,
} from 'store/actions/notificationActions';
import find from 'lodash-es/find';


const initialState = [];
export default (previousState = initialState, { type, payload, newNotification, notificationKey }) => {
  switch (type) {
    case SHOW_NOTIFICATION:
      // 동일한 category의 Noti가 이미 있는 경우 추가 안 함
      if( newNotification.category ) {
        const sameNotification = find(previousState, ["category", newNotification.category]);
        if( sameNotification ) {
          return previousState;
        }
      }
      return [
        ...previousState,
        newNotification
      ];

    case HIDE_NOTIFICATION:
      if(!notificationKey) { // notificationKey 없이 호출한 경우 이전 알림 모두 삭제되게 수정 
        return initialState;
      }
      return previousState.filter(notification => notification.key !== notificationKey);

    default:
      return previousState;
  }
};